import { useLocation, useNavigate } from 'react-router-dom';
import { MenuItem as MenuItemType } from '../../types';
import { useState } from 'react';
import CloseGameModal from './CloseGameModal';
import MenuItemLink from './MenuItemLink';
import MenuItemButton from './MenuItemButton';

type MenuItemProps = {
  item: MenuItemType;
  numPlayers: number;
};

function MenuItem({ item, numPlayers }: MenuItemProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const [showCloseGameModal, setShowCloseGameModal] = useState(false);

  const isSelected = location.pathname === item.link;
  const isLastPlayer = numPlayers === 1;

  function handleNavigate() {
    setShowCloseGameModal(false);
    if (item.link.includes('http')) {
      window.open(item.link, '_blank');
      return;
    }
    navigate(item.link);
  }

  if (!isLastPlayer) {
    return <MenuItemLink item={item} isSelected={isSelected} />;
  } else {
    return (
      <>
        <MenuItemButton
          item={item}
          isSelected={isSelected}
          onClick={() => setShowCloseGameModal(true)}
        />

        <CloseGameModal
          show={showCloseGameModal}
          close={() => setShowCloseGameModal(false)}
          onConfirm={handleNavigate}
          onReject={() => setShowCloseGameModal(false)}
        />
      </>
    );
  }
}

export default MenuItem;
